import React from "react";

const NewContent = () => {
  return <div>NewContent</div>;
};

export default NewContent;
